export class Message {
    public isUser: boolean;
    public text: string;
    public isAi: boolean;
    public isAction: boolean;
    public isThinking: boolean;
    public isNudge?: boolean;   // rescue nudge -> full-width bubble (matches the step card above)
    public isComposeThinking?: boolean;   // abx #4: set ONLY during a tap-compose beat; step gates key off THIS, not generic isThinking, so levers-off == today
    // Trusted/sanitized landing intro supplied by ChatComponent. It renders before the Markdown
    // question inside the SAME Hope bubble, preserving visible semantic H1/H2/H3 tags.
    public semanticIntroHtml?: string;
    // FRU-23989: on desktop the rate-bearing introduction sits in the bubble; it shows only while the rate scope its pair came
    // from is still the active one, as the desktop headline does. Unset on phones (no change there).
    public semanticIntroInScope?: () => boolean;
    // Ed 2026-09-24: the first screen's bubble says what Hope is, next to her label.
    public introduceHope?: boolean;
    public semanticIntroPlainText?: string;
    // FRU-23221: the first-screen framing test hides the "Hope" sender label on this one bubble.
    public hideSender?: boolean;
    // For multiple lines
    public timestamp: Date;

    constructor(
        isUser: boolean,
        text: string,
        isAi?: boolean,
        isAction?: boolean,
        isThinking?: boolean,
    ) {
        this.isUser = isUser || false;
        this.text = text || '';
        this.isAi = isAi || false;
        this.isAction = isAction || false;
        this.isThinking = isThinking || false;
        this.isNudge = false;
        this.isComposeThinking = false;
        this.semanticIntroHtml = '';
        this.semanticIntroPlainText = '';
        this.timestamp = new Date();
    }
}
